export const placas = {1: {'max_largo': 2585, 'max_ancho': 1815, 'largo': 2600, 'ancho': 1830, 'mm': 18}, 2: {'max_largo': 2585, 'max_ancho': 1815, 'largo': 2600, 'ancho': 1830, 'mm': 18}, 3: {'max_largo': 2750, 'max_ancho': 1830, 'largo': 2750, 'ancho': 1830, 'mm': 18}}



// WEBPACK FOOTER //
// ./src/store/placas.js